module.exports = __webpack_public_path__ + "img/oil.01900231.webp";